import { render, staticRenderFns } from "./saleRewardDetail.vue?vue&type=template&id=346cb7aa&scoped=true&"
import script from "./saleRewardDetail.vue?vue&type=script&lang=js&"
export * from "./saleRewardDetail.vue?vue&type=script&lang=js&"
import style0 from "./saleRewardDetail.vue?vue&type=style&index=0&id=346cb7aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346cb7aa",
  null
  
)

export default component.exports